import React from 'react';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';

import Panel from '../ui/Panel';

/** Server-side bulk effort estimation run using TypeSafe Jev. */
const JevEstimationSection = ({
  onStart,
  onStop,
  loading,
  status,
}) => (
  <Panel
    title="Jev Effort Estimation"
    subtitle="Estimate missing ticket effort with TypeSafe Jev's structured decisions."
  >
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
      <Button variant="contained" startIcon={<PlayArrowIcon />} onClick={onStart} disabled={loading}>
        Start Estimation
      </Button>
      <Button variant="outlined" startIcon={<StopIcon />} onClick={onStop} disabled={!loading}>
        Stop Estimation
      </Button>
      {loading && <CircularProgress size={20} />}
    </Stack>
    {status && <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1.5 }}>Status: {status}</Typography>}
  </Panel>
);

export default JevEstimationSection;
